import http from "../../utils/http"


/**
 * 获取企业分类接口
 */

 export function getbusinessInfo(params) {
    let url 
    params.name ? url = "/platform/business/classify/page?name=" + params.name + '&current=' + params.current + '&size=' + params.size : url = '/platform/business/classify/page?current=' + params.current + '&size=' + params.size
    return http({
        url: url,
        method:'get',
        data: params,
    })
}
export function getbusinesstypelist(params) {
    return http({
        url: '/platform/business/classify/list',
        method:'get',
        data: params,
    })
}
/**
 * 修改新增企业分类接口
 */
 export function getbusinessedit(params,method) {
    return http({
        url: "/platform/business/classify",
        method:method,
        data: params,
    })
}
/**
 * 删除企业分类接口
 */
 export function deletList(params,method) {
    return http({
        url: "/platform/business/classify/" + params.id,
        method:method,
        data: params,
    })
}

/**
 * 获取企业列表接口
 */

 export function getbusinessList(params) {
    let url
    if(params.name || params.id || params.phone || params.classifyIds || params.state || params.accountState || params.startTime){
        url = "/platform/business/page?name=" + params.name + '&id=' + params.id + '&phone=' + params.phone + '&current=' + params.current + '&size=' + params.size + '&classifyIds=' + params.classifyIds + '&state=' + params.state + '&accountState=' + params.accountState + '&startTime=' + params.startTime + '&endTime=' + params.endTime
    }else{
        url = "/platform/business/page?current=" + params.current + '&size=' + params.size
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 修改企业状态
 */

 export function editbusinessStatus(params,method) {
    return http({
        url: "/platform/business/updateAccountStatus",
        method:method,
        data: params,
    })
}

/**
 * 新增企业
 */
 export function addbusiness(params,method) {
    return http({
        url: "/platform/business",
        method:method,
        data: params,
    })
}
/**
 * 企业详情
 * 
 */
 export function businessDetail(params) {
    return http({
        url: "/platform/business/" + params.id,
        method:'get',
        data: params,
    })
}

/**
 * 帮助列表
 * 
 */

 export function gethelpList(params) {
    let url
    if(params.name || params.id || params.state || params.startTime || params.appName || params.appId || params.classifyId || params.officialType){
        url = "/platform/support/page?title=" + params.name + '&id=' + params.id + '&current=' + params.current + '&size=' + params.size + '&state=' + params.state + '&startTime=' + params.startTime + '&endTime=' + params.endTime + '&appName=' + params.appName + '&appId=' + params.appId + '&appClassifyId=' + params.classifyId + '&officialType=' + params.officialType
    }else{
        url = "/platform/support/page?current=" + params.current + '&size=' + params.size
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 新增修改
 * 
 */

 export function edithelpStatus(params,method) {
    return http({
        url: "/platform/support",
        method:method,
        data: params,
    })
}

/**
 * 查询帮助基本信息
 * 
 */
 export function helpDetail(params) {
    return http({
        url: "/platform/support/" + params.id,
        method:"get",
        data: params,
    })
}

/**
 * 删除帮助基本信息
 * 
 */
 export function delhelp(params) {
    return http({
        url: "/platform/support/" + params.id,
        method:"DELETE",
        data: params,
    })
}


/**
 * 图片上传
 * 
 */

 export function upLoad(params) {
    return http({
        url: "/admin/sys-file/upload",
        method:"post",
        data: params,
    })
}


/**
 * 章节列表
 * 
 */
 export function chapterList(params) {
    return http({
        url: "/platform/support/chapter/list/" + params.id,
        method:"get",
        data: params,
    })
}

/**
 * 新增章节
 * 
 */


 export function edithelpChapter(params,method) {
    return http({
        url: "/platform/support/chapter",
        method:method,
        data: params,
    })
}


/**
 * 章节详情
 * 
 */

 export function chapterDetail(params) {
    return http({
        url: "/platform/support/chapter/" + params.id,
        method:"get",
        data: params,
    })
}

/**
 * 删除章节
 * 
 */

 export function delChapter(params) {
    return http({
        url: "/platform/support/chapter/" + params.id,
        method:"DELETE",
        data: params,
    })
}



/**
 * 权限列表
 * 
 */

 export function businessRole(params) {
    return http({
        url: "/platform/businessRole/" + params.id,
        method:"get",
        data: params,
    })
}

/**
 * 选择企业
 * 
 */
 export function chooseRole(params) {
    return http({
        url: "/platform/businessRole",
        method:"post",
        data: params,
    })
}


/**
 * 富文本保存
 * 
 */
 export function helpEditor(params) {
    return http({
        url: "/platform/support/chapter",
        method:"PUT",
        data: params,
    })
}

/**
 * 预览帮助课程详细信息
 * 
 */

export function preview(params) {
    return http({
        url: "/platform/support/view/" + params.id + '?name=' + params.name,
        method:"get",
        data: params,
    })
}

/**
 * 获取企业管理员列表
 * 
 */

 export function getbusinessAccountList(params) {
    let url
    if(params.id || params.userName || params.businessId || params.businessName || params.loginName){
        url = "/platform/business/account/page?id=" + params.id + '&userName=' + params.userName + '&businessId=' + params.businessId + '&businessName=' + params.businessName + '&current=' + params.current + '&size=' + params.size + '&loginName=' + params.loginName + '&source=' + params.source
    }else{
        url = "/platform/business/account/page?current=" + params.current + '&size=' + params.size + '&source=' + params.source
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}
/**
 * 获取用户列表
 * 
 */
 export function getUserList(params) {
    let url
    if(params.id || params.userName || params.businessId || params.businessName || params.loginName || params.createTimeStart || params.loginTimeStart || params.state || params.channel){
        url = "/platform/business/account/page?id=" + params.id + '&userName=' + params.userName + '&businessId=' + params.businessId + '&businessName=' + params.businessName + '&current=' + params.current + '&size=' + params.size + '&loginName=' + params.loginName + '&source=' + params.source + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd='+ params.createTimeEnd + '&loginTimeStart=' + params.loginTimeStart + '&loginTimeEnd=' + params.loginTimeEnd + '&state=' + params.state + '&channel=' + params.channel
    }else{
        url = "/platform/business/account/page?current=" + params.current + '&size=' + params.size + '&source=' + params.source
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
 }
/**
 * 新增修改企业管理员
 * 
 */

export function editAccount(params,method) {
    return http({
        url: "/platform/business/account",
        method:method,
        data: params,
    })
}


/**
 * 企业管理员详情
 * 
 */

 export function businessAccountDetail(params) {
    return http({
        url: "/platform/business/account/" + params.id,
        method:'get',
        data: params,
    })
}

/**
 * 删除企业管理员
 * 
 */

 export function delbusinessAdmin(params) {
    return http({
        url: "/platform/business/account/" + params.id,
        method:"DELETE",
        data: params,
    })
}

/**
 * 应用分类
 * 
 */

 export function getApplicationTypeList(params) {
    return http({
        url: "/platform/appClassify/treeList?name=" + params.name + '&officialType=' + params.officialType,
        method:'get',
        data: params,
    })
}

/**
 * 新增修改应用分类
 * 
 */

export function editApplicationType(params,method) {
    return http({
        url: "/platform/appClassify",
        method:method,
        data: params,
    })
}

/**
 * 删除应用分类
 * 
 */

 export function delApplicationType(params) {
    return http({
        url: "/platform/appClassify/" + params.id,
        method:"DELETE",
        data: params,
    })
}

/**
 * 获取企业列表接口
 */

 export function getApplicationList(params) {
    let url
    let payModel = ""
    if(params.appName || params.id || params.classifyId || params.state || params.type || params.payType){
        if(params.payType == "sku1") params.payType = 2,payModel = 1
        if(params.payType == "sku2") params.payType = 2,payModel = 2
        url = "/platform/app/page?appName=" + params.appName + '&id=' + params.id + '&current=' + params.current + '&size=' + params.size + '&classifyId=' + params.classifyId + '&state=' + params.state + '&type=' + params.type + '&payType=' + params.payType + '&payModel=' + payModel + '&officialType=' + params.officialType
    }else{
        url = "/platform/app/page?current=" + params.current + '&size=' + params.size
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 获取应用列表 （新增帮助时选择）
 */


/**
 * 新增修改应用列表
 * 
 */
export function helpAppList(params) {
    let url = params.parentClassifyId ? `/platform/app/list?parentClassifyId=${params.parentClassifyId}&type=1&state=1` : '/platform/app/list?type=1&state=1' + '&officialType=' + params.officialType
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

 export function editApplication(params,method) {
    return http({
        url: "/platform/app",
        method:method,
        data: params,
    })
}


/**
 * 获取日志列表接口
 */

 export function getAppLoginLog(params,type) {
    let url
    let paramsdata = '?appName=' + params.appName + '&username=' + params.username + '&current=' + params.current + '&size=' + params.size  + '&startTime=' + params.startTime + '&endTime=' + params.endTime
    let paramsdata1 = '?appName=' + params.appName + '&username=' + params.username +  '&businessName='+ params.businessName + '&current=' + params.current + '&size=' + params.size  + '&startTime=' + params.startTime + '&endTime=' + params.endTime
    //appLogin表示应用登录日志，appOperate表示应用操作日志
    if(type == "appLogin"){
    if(params.appName || params.username  || params.businessName || params.startTime){
        url = "/admin/log/appLogin/page" + paramsdata1
    }else{
        url = "/admin/log/appLogin/page?current=" + params.current + '&size=' + params.size
    }
    }else{
        if(params.appName || params.username  || params.startTime){
            url = "/admin/log/appOperate/page" + paramsdata
        }else{
            url = "/admin/log/appOperate/page?current=" + params.current + '&size=' + params.size
        }
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 应用详情
 * 
 */

 export function AppDetail(params) {
    return http({
        url: "/platform/app/" + params.id,
        method:'get',
        data: params,
    })
}

/**
 * 版本列表
 * 
 */
 export function getAppVersionList(params) {
    let url
    if(params.versionNum || params.startTime || params.versionType){
        url = "/platform/appVersion/page?appId=" + params.appId + '&versionNum=' + params.versionNum + '&current=' + params.current + '&size=' + params.size + '&createTimeStart=' + params.startTime + '&createTimeEnd=' + params.endTime + '&versionType=' + params.versionType
    }else{
        url = "/platform/appVersion/page?appId=" + params.appId + '&size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 回退版本列表
 * 
 */

 export function ApprebackList(params) {
    return http({
        url: "/platform/appVersion/list/" + params.id,
        method:'get',
        data: params,
    })
}

/**
 * 新增查看回退应用
 * 
 */

 export function appAllfun(params,method) {
    let url
    method == "post" ? url = '/platform/appVersion' : url = '/platform/appVersion/' + params.id
    return http({
        url: url,
        method:method,
        data: params,
    })
}

/**
 * 授权列表
 * 
 */


 export function getAppAuthList(params) {
    let url
    url = "/platform/appAuthority/page?appId=" + params.appId + '&businessName=' + params.businessName + '&current=' + params.current + '&size=' + params.size + '&businessId=' + params.businessId + '&appName=' + params.appName + '&createBy=' + params.createBy + '&type=' + params.type + '&businessClassifyName=' + params.businessClassifyName + '&expireStartTime=' + params.expireStartTime + '&expireEndTime=' + params.expireEndTime + '&officialType=' + params.officialType + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 新增授权
 * 
 */

 export function appAuthfun(params,method) {
    let url
    method == "post" ? url = '/platform/appAuthority' : url = '/platform/appAuthority/' + params.id
    return http({
        url: url,
        method:method,
        data: params,
    })
}
/**
 * 课程授权列表
 * 
 */


export function getCourseAuthList(params) {
    let url
    url = "/platform/courseAuthority/page?courseId=" + params.appId + '&businessName=' + params.businessName + '&current=' + params.current + '&size=' + params.size + '&businessId=' + params.businessId + '&courseName=' + params.appName + '&createBy=' + params.createBy + '&type=' + params.type + '&businessClassifyId=' + params.businessClassifyName + '&expireStartTime=' + params.expireStartTime + '&expireEndTime=' + params.expireEndTime + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd
    return http({ 
        url: url,
        method:'get',
        data: params,
    })
}
/**
 * 新增课程授权
 * 
 */

export function courseAuthfun(params,method) {
    let url
    method == "post" ? url = '/platform/courseAuthority' : url = '/platform/courseAuthority/' + params.id
    return http({
        url: url,
        method:method,
        data: params,
    })
}
/**
 * 用户注册渠道列表
 * 
 */
 export function channelList(params) {
    return http({
        url: "/platform/business/account/channelList",
        method:'get',
        data: params,
    })
}

/**
 * 线索类型列表
 * 
 */
 export function clueTypeList(params) {
    return http({
        url: "/platform/business/account/clueTypeList",
        method:'get',
        data: params,
    })
}

/**
 * 线索列表
 * 
 */
 export function getClueList(params) {
    let  url
    if(params.id || params.businessName || params.businessId || params.accountId || params.loginName || params.clueType || params.applyTimeStart){
        url =  url = '/platform/business/account/pageAccountClue?id=' + params.id + '&accountId=' + params.accountId + '&businessName=' + params.businessName + '&businessId=' + params.businessId + '&loginName=' + params.loginName + '&clueType=' + params.clueType + '&applyTimeStart=' + params.applyTimeStart + '&applyTimeEnd=' + params.applyTimeEnd + '&size=' + params.size + '&current=' + params.current
    }else{
       url = '/platform/business/account/pageAccountClue?size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 跟进列表
 * 
 */

 export function followList(params) {
    return http({
        url: "/platform/business/account/follow/" + params.id,
        method:'get',
        data: params,
    })
}
/**
 * 问题反馈跟进列表
 * 
 */

export function feedbackFollowList(params) {
    return http({
        url: "/platform/feedback/follow/list?feedbackId=" + params.id,
        method:'get',
        data: params,
    })
}
/**
 * 简历跟进列表
 * 
 */

export function followList1(params) {
    return http({
        url: `/platform/job/resume/follow/list/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *客户咨询跟进列表
 * 
 */

export function followList2(params) {
    return http({
        url: `/platform/consult/followList/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 * 添加跟进
 * 
 */
 export function addFo(params) {
    return http({
        url: "/platform/business/account/saveFollow",
        method:'post',
        data: params,
    })
}

/**
 * 简历添加跟进
 * 
 */
export function addFo1(params) {
    return http({
        url: "/platform/job/resume/follow",
        method:'post',
        data: params,
    })
}
/**
 * 客户咨询添加跟进
 * 
 */
export function addFo2(params) {
    return http({
        url: "/platform/consult/follow",
        method:'post',
        data: params,
    })
}
/**
 * 添加跟进
 * 
 */
export function addFo3(params) {
    return http({
        url: "/platform/feedback/follow",
        method:'post',
        data: params,
    })
}
/**
 * 线索列表
 * 
 */
export function getConList(params) {
    let  url
    if(params.id ||  params.phone || params.type  || params.createTimeStart){
        url =  url = '/platform/consult/page?id=' + params.id + '&phone=' + params.phone + '&type=' + params.type + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd + '&size=' + params.size + '&current=' + params.current
    }else{
       url = '/platform/consult/page?size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}
/**
 * 积分修改
 * 
 */

 export function updateScore(params) {
    return http({
        url: "/platform/business/account/updateScore",
        method:'put',
        data: params,
    })
}

/**
 * 积分明细列表
 * 
 */
 export function scoreList(params) {
    return http({
        url: "/platform/business/account/scoreList/" + params.id + '?source=' + params.source + '&operateTimeStart=' + params.operateTimeStart + '&operateTimeEnd=' + params.operateTimeEnd,
        method:'get',
        data: params,
    })
}

/**
 * 规格列表
 * 
 */

 export function skuList(params) {
    return http({
        url: "/platform/app/skuList/" + params.id,
        method:'get',
        data: params,
    })
}

/**
 * 轮播图列表
 * 
 */
 export function websiteBanner(params) {
    let  url
    if(params.id || params.name || params.channelFirst || params.channelSecond || params.state || params.createTimeStart || params.orderBy){
        url =  url = '/platform/websiteBanner/page?id=' + params.id + '&name=' + params.name + '&channelFirst=' + params.channelFirst + '&channelSecond=' + params.channelSecond + '&state=' + params.state + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd + '&orderBy=' + params.orderBy + '&size=' + params.size + '&current=' + params.current
    }else{
       url = '/platform/websiteBanner/page?size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}
/**
 * 轮播图状态改变
 * 
 */
 export function bannerState(params) {
    return http({
        url: "/platform/websiteBanner/updateStatus",
        method:'put',
        data: params,
    })
}

/**
 * 轮播图删除、查询
 * 
 */

 export function deleteBanner(params,method) {
    return http({
        url: "/platform/websiteBanner/" + params.id,
        method:method,
        data: params,
    })
}

/**
 * 轮播图保存、修改
 * 
 */

 export function editBanner(params,method) {
    return http({
        url: "/platform/websiteBanner",
        method:method,
        data: params,
    })
}
/**
 * 轮播图排序
 * 
 */
 export function updateSort(params) {
    return http({
        url: "/platform/websiteBanner/updateSort",
        method:'put',
        data: params,
    })
}

/**
 * 订单列表
 * 
 */

 export function orderList(params) {
    let  url
    if(params.id || params.businessId || params.businessName || params.orderStatus || params.orderStatus == 0 || params.payType || params.createTimeStart || params.officialType || params.orderType){
        url =  url = '/platform/order/page?id=' + params.id + '&businessName=' + params.businessName + '&businessId=' + params.businessId + '&orderStatus=' + params.orderStatus + '&payType=' + params.payType + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd + '&size=' + params.size + '&current=' + params.current + '&officialType=' + params.officialType + '&orderType=' + params.orderType
    }else{
       url = '/platform/order/page?size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 订单列表详情
 * 
 */

 export function orderDetail(params) {
    return http({
        url: "/platform/order/" + params.id,
        method:'get',
        data: params,
    })
}

/**
 * 备注、关闭订单
 * 
 */

export function closeOrder(params) {
    return http({
        url: "/platform/order",
        method:"PUT",
        data: params,
    })
}


/**
 * 修改订单费用
 * 
 */

export function updateOrderFee(params) {
    return http({
        url: "/platform/order/updateOrderFee",
        method:'put',
        data: params,
    })
}

/**
 *  订单状态条数统计
 * 
 */

export function countOrder(params) {
    return http({
        url: "/platform/order/countOrder",
        method:'get',
        data: params,
    })
}

/**
 *  保存和隆优化页面配置信息
 * 
 * 
 */

export function websitePage(params) {
    return http({
        url: "/platform/websitePage",
        method:'post',
        data: params,
    })
}
/**
 *  保存和隆软件页面配置信息
 * 
 * 
 */

export function websiteSoft(params) {
    return http({
        url: "/platform/websiteSoft",
        method:'post',
        data: params,
    })
}
/**
 *  
 * 查询页面配置信息列表
 * 
 */
export function websitePageList(params) {
    return http({
        url: "/platform/websitePage/list?type=" + params.type,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 查询和隆官网页面配置信息列表
 * 
 */
export function websiteSoftPageList(params) {
    return http({
        url: "/platform/websiteSoft/list?type=" + params.type,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 查询解决分类
 * 
 */

export function solutionClassify(params) {
    return http({
        url: `/platform/solutionClassify/list?name=${params.name}&officialType=${params.officialType}`,
        method:'get',
        data: params,
    })
}


/**
 *  
 * 分页查询解决列表
 * 
 */

export function solutionList(params) {
    let  url
    if(params.id || params.classifyId || params.state || params.name ||  params.createTimeStart || params.officialType){
        url =  url = '/platform/solution/page?id=' + params.id + '&classifyId=' + params.classifyId + '&name=' + params.name + '&state=' + params.state + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd + '&size=' + params.size + '&current=' + params.current + '&officialType=' + params.officialType
    }else{
       url = '/platform/solution/page?size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}


/**
 *  
 * 新增解决列表
 * 
 */

export function editSolution(params,method) {
    return http({
        url: "/platform/solution",
        method:method,
        data: params,
    })
}

/**
 *  
 * 查询、删除解决方案详情
 * 
 */

export function getSolution(params,method) {
    return http({
        url: "/platform/solution/" + params.id,
        method:method,
        data: params,
    })
}


/**
 *  
 * 分页查询解决方案分类
 * 
 */

export function getSolutionClassify(params) {
    let url= "/platform/solutionClassify/page?name=" + params.name + '&current=' + params.current + '&size=' + params.size + '&officialType=' + params.officialType 
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 删除解决方案分类接口
 */
export function deletSolutionList(params,method) {
    return http({
        url: "/platform/solutionClassify/" + params.id,
        method:method,
        data: params,
    })
}

/**
 * 修改新增解决方案分类接口
 */
export function getSolutionedit(params,method) {
    return http({
        url: "/platform/solutionClassify",
        method:method,
        data: params,
    })
}

/**
 *  
 * 查询新闻分类
 * 
 */

export function newsClassify(params) {
    return http({
        url: `/platform/newsClassify/list?name=${params.name}&officialType=${params.officialType}`,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 分页查询新闻列表
 * 
 */

export function newsList(params) {
    let  url
    if(params.id || params.classifyId || params.state || params.name ||  params.createTimeStart || params.officialType){
        url =  url = '/platform/news/page?id=' + params.id + '&classifyId=' + params.classifyId + '&name=' + params.name + '&state=' + params.state + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd + '&size=' + params.size + '&current=' + params.current + '&officialType=' + params.officialType
    }else{
       url = '/platform/news/page?size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增修改新闻
 * 
 */

export function editNews(params,method) {
    return http({
        url: "/platform/news",
        method:method,
        data: params,
    })
}

/**
 *  
 * 查询、删除解决方案详情
 * 
 */

export function getNews(params,method) {
    return http({
        url: "/platform/news/" + params.id,
        method:method,
        data: params,
    })
}

/**
 *  
 * 分页查询新闻分类
 * 
 */

export function getNewsClassify(params) {
    let url 
    url = "/platform/newsClassify/page?name=" + params.name + '&current=' + params.current + '&size=' + params.size  + '&officialType=' + params.officialType
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 删除新闻分类接口
 */
export function deletNewsList(params,method) {
    return http({
        url: "/platform/newsClassify/" + params.id,
        method:method,
        data: params,
    })
}

/**
 * 修改新增解决方案分类接口
 */
export function getNewsedit(params,method) {
    return http({
        url: "/platform/newsClassify",
        method:method,
        data: params,
    })
}
/**
 * 职位分类
 */
export function jobClassify(params) {
    return http({
        url: `/platform/jobClassify/list?name=${params.name}&officialType=${params.officialType}`,
        method:'get',
        data: params,
    })
}
/**
 * 分页查询人才岗位
 */

export function jobList(params) {
    let  url
    if(params.id || params.classifyId || params.state || params.name ||  params.degree || params.jobCategory || params.experience || params.hiringNeeds || params.workplace || params.createTimeStart || params.officialType){
        url =  url = '/platform/job/page?id=' + params.id + '&classifyId=' + params.classifyId + '&name=' + params.name + '&degree=' + params.degree + '&jobCategory=' + params.jobCategory + 
        '&experience=' + params.experience + '&hiringNeeds=' + params.hiringNeeds + '&workplace=' + params.workplace + '&state=' + params.state + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd + '&size=' + params.size + '&current=' + params.current + '&officialType=' + params.officialType
    }else{
       url = '/platform/job/page?size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 修改新增人才岗位接口
 */
export function editJob(params,method) {
    return http({
        url: "/platform/job",
        method:method,
        data: params,
    })
}

/**
 *  
 * 查询、删除人才岗位详情
 * 
 */

export function getJob(params,method) {
    return http({
        url: "/platform/job/" + params.id,
        method:method,
        data: params,
    })
}

/**
 *  
 * 分页查询岗位分类
 * 
 */

export function getJobClassify(params) {
    let url 
   url = "/platform/jobClassify/page?name=" + params.name + '&current=' + params.current + '&size=' + params.size + '&officialType=' + params.officialType
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 删除岗位分类接口
 */
export function deletJobList(params,method) {
    return http({
        url: "/platform/jobClassify/" + params.id,
        method:method,
        data: params,
    })
}


/**
 * 修改新增岗位分类接口
 */
export function getJobedit(params,method) {
    return http({
        url: "/platform/jobClassify",
        method:method,
        data: params,
    })
}
/**
 *  
 * 分页查询简历
 * 
 */

export function resumeList(params) {
    let  url = "/platform/job/resume/page?jobId=" + params.id + '&current=' + params.current + '&size=' + params.size 
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 查询案例分类
 * 
 */
export function caseClassify(params) {
    return http({
        url: `/platform/caseClassify/list?name=${params.name}&officialType=${params.officialType}`,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 分页查询案例分类
 * 
 */

export function getcaseClassify(params) {
    let url 
     url = "/platform/caseClassify/page?name=" + params.name + '&current=' + params.current + '&size=' + params.size + '&officialType=' + params.officialType
    return http({
        url: url,
        method:'get',
        data: params,
    })
}

/**
 * 修改新增案例分类接口
 */
export function getCaseedit(params,method) {
    return http({
        url: "/platform/caseClassify",
        method:method,
        data: params,
    })
}


/**
 * 删除案例分类接口
 */
export function deletCaseList(params,method) {
    return http({
        url: "/platform/caseClassify/" + params.id,
        method:method,
        data: params,
    })
}

/**
 *  
 * 分页查询案例列表
 * 
 */

export function caseList(params) {
    let  url
    if(params.id || params.classifyId || params.state || params.name ||  params.createTimeStart || params.officialType){
        url =  url = '/platform/case/page?id=' + params.id + '&classifyId=' + params.classifyId + '&name=' + params.name + '&state=' + params.state + '&createTimeStart=' + params.createTimeStart + '&createTimeEnd=' + params.createTimeEnd + '&size=' + params.size + '&current=' + params.current + '&officialType=' + params.officialType
    }else{
       url = '/platform/case/page?size=' + params.size + '&current=' + params.current
    }
    return http({
        url: url,
        method:'get',
        data: params,
    })
}


/**
 *  
 * 查询、删除案例详情
 * 
 */

export function getCase(params,method) {
    return http({
        url: "/platform/case/" + params.id,
        method:method,
        data: params,
    })
}

/**
 *  
 * 新增案例
 * 
 */

export function editCase(params,method) {
    return http({
        url: "/platform/case",
        method:method,
        data: params,
    })
}
// 文件上传获取签名
export function policy(params) {
    return http({
        url: "/admin/sys-file/policy",
        method:'post',
        data: params,
    })
}
/**
 *  
 * 分页查询题目分类
 * 
 */

export function gettopicClassify(params) {
    return http({
        url:`/platform/questionClassify/page?name=${params.name}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 查询题目分类
 * 
 */
export function getAllTopicClassify(params) {
    return http({
        url:`/platform/questionClassify/list?name=${params.name}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增题目分类
 * 
 */
export function editTopic(params,method) {
    return http({
        url: "/platform/questionClassify",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询、删除详情
 * 
 */

export function getTopic(params,method) {
    return http({
        url: `/platform/questionClassify/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 分页查询题目列表
 * 
 */

export function gettopicList(params) {
    return http({
        url:`/platform/question/page?title=${params.title}&createBy=${params.createBy}&id=${params.id}&tags=${params.tags}&types=${params.types}&classifyId=${params.classifyId}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 新增、修改题目
 * 
 */

export function editQuestion(params,method) {
    return http({
        url: "/platform/question",
        method:method,
        data: params,
    })
}
/**
 *  
 * 修改试卷中的题目题目
 * 
 */
export function editPaperQuestion(params) {
    return http({
        url: "/platform/paper/paperQuestions",
        method:'PUT',
        data: params,
    })
}
/**
 *  
 * 获取题目详情
 * 
 */

export function getQuestion(params,method) {
    return http({
        url: `/platform/question/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 获取试卷题目详情
 * 
 */
export function getPaperQuestion(params) {
    return http({
        url: `/platform/paper/paperQuestions/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 获取题目统计
 * 
 */
export function questionCount(params) {
    return http({
        url: `/platform/question/count/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 移动到分类
 * 
 */
export function moveQuestion(params) {
    return http({
        url: "/platform/question/batchUpdateClassify",
        method:'put',
        data: params,
    })
}

/**
 *  
 * 题库去重
 * 
 */
export function getRepeat(params) {
    return http({
        url:'/platform/question/processQuestionsDuplication',
        method:'get',
        data: params,
    })
}

/**
 *  
 * 导入第二步
 * 
 */

export function checkHaveDuplicate(params) {
    return http({
        url: "/platform/question/checkHaveDuplicate",
        method:'post',
        data: params,
    })
}
/**
 *  
 * 导入试题
 * 
 */

export function importSave(params) {
    return http({
        url: "/platform/question/importSave",
        method:'post',
        data: params,
    })
}
/**
 *  
 * 试卷分类
 * 
 */

export function listTree(params) {
    return http({
        url:`/platform/paperClassify/listTree?name=${params.name}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增试卷分类
 * 
 */
export function editPaper(params,method) {
    return http({
        url: "/platform/paperClassify",
        method:method,
        data: params,
    })
}



/**
 * 删除试卷分类
 * 
 */

export function delpaperClassify(params,method) {
    return http({
        url: `/platform/paperClassify/${params.id}`,
        method:method,
        data: params,
    })
}

/**
 * 分页查询试卷
 * 
 */

export function getPaperList(params) {
    return http({
        url:`/platform/paper/page?paperName=${params.paperName}&id=${params.id}&validPeriod=${params.validPeriod}&state=${params.state}&classifyId=${params.classifyId}&practiceMode=${params.practiceMode}&questionId=${params.questionId}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 新增试卷
 * 
 */

export function editPapeItem(params,method) {
    return http({
        url: "/platform/paper",
        method:method,
        data: params,
    })
}

/**
 *  
 * 获取试卷详情
 * 
 */

export function getPaper(params,method) {
    return http({
        url: `/platform/paper/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 试卷ID查询仿真列表
 * 
 */
export function getPaperFzList(params) {
    return http({
        url: `/platform/paper/appList/${params.id}`,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 随机试题组卷
 * 
 */
export function randomPaper(params) {
    return http({
        url: "/platform/paper/paperQuestions/random",
        method:"post",
        data: params,
    })
}

/**
 *  
 * 固定试题组卷
 * 
 */
export function regularPaper(params) {
    return http({
        url: "/platform/paper/paperQuestions",
        method:"post",
        data: params,
    })
}
/**
 *  
 * 试卷ID查询题目列表
 * 
 */
export function getAllTopic(params) {
    return http({
        url: `/platform/paper/paperQuestions/list/${params.id}`,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 试卷ID删除试题
 * 
 */
export function topicDelet(params) {
    return http({
        url: `/platform/paper/paperQuestions/${params.id}?delQuestion=${params.delQuestion}`,
        method:'DELETE',
        data: params,
    })
}
/**
 *  
 * 试卷ID评分列表
 * 
 */
export function getComments(params) {
    return http({
        url: `/platform/paper/commentList/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 试题查重
 * 
 */
export function duplicateList(params) {
    return http({
        url: `/platform/paper/paperQuestions/duplicateList?paperId=${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 批量修改分数
 * 
 */

export function updatePaperScore(params) {
    return http({
        url: "/platform/paper/paperQuestions/updateScore",
        method:'put',
        data: params,
    })
} 
/**
 *  
 * 考试成绩分析
 * 
 */
export function scoreAnalysis(params) {
    return http({
        url: `/platform/result/scoreAnalysis?paperId=${params.id}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 分数段统计
 * 
 */
export function segmentList(params) {
    return http({
        url: "/platform/result/segmentList",
        method:"post",
        data: params,
    })
}
/**
 *  
 * 各类题型正确率
 * 
 */
export function countQuestionType(params) {
    return http({
        url: `/platform/result/countQuestionType?paperId=${params.id}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 试题排行分析
 * 
 */
export function questionRankList(params) {
    return http({
        url: `/platform/result/questionRankList?paperId=${params.id}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}&doRight=${params.doRight}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 *排行榜列表
 * 
 */
export function rankList(params) {
    return http({
        url: `/platform/result/rankPage?paperId=${params.paperId}&practiceMode=${params.practiceMode}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
    })
}
/**
 * 考试记录分页面
 * 
 */

export function ResultList(params) {
    return http({
        url:`/platform/result/page?paperId=${params.id}&practiceMode=${params.practiceMode}&result=${params.result}&examiner=${params.examiner}&examinerPhone=${params.examinerPhone}&startTimeStart=${params.startTimeStart}&startTimeEnd=${params.startTimeEnd}&state=${params.state}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}

/**
 * 查看成绩单
 * 
 */
export function resulttRanscript(params) {
    return http({
        url: `/platform/result/${params.id}`,
        method:"get",
        data: params,
    })
}

/**
 * 考试监控基本信息
 * 
 */
export function monitor(params) {
    let ptype = (params.practiceMode == 1 || params.practiceMode == 0)  ? params.practiceMode : ''
    return http({
        url: `/platform/result/monitor/${params.id}?practiceMode=${ptype}`,
        method:"get",
        data: params,
    })
}
/**
 * 考试查询试卷息
 * 
 */
export function paperExam(params) {
    return http({
        url: `/exam/result/paperExam/${params.id}?view=${params.view}`,
        method:"get",
        data: params,
    })
}
/**
 * 考试监控日志
 * 
 */
export function resultMonitorLog(params) {
    return http({
        url: `/platform/result/log/list?resultId=${params.id}`,
        method:"get",
        data: params,
    })
}
/**
 * 强制交卷
 * 
 */
export function forceSubmit(params) {
    return http({
        url: `/platform/result/forceSubmit/${params.id}`,
        method:"put",
        data: params,
    })
}
/**
 *  
 * 删除记录
 * 
 */
export function deletResult(params) {
    return http({
        url: `/platform/result/${params.id}`,
        method:'DELETE',
        data: params,
    })
}
/**
 *  
 * 复制试卷
 * 
 */
export function copyPa(params) {
    return http({
        url: "/platform/paper/copy",
        method:"post",
        data: params,
    })
}

/**
 *  
 * 电子名片-分页查询接口
 * 
 */
export function getVcard(params) {
    return http({
        url:`/platform/vcard/page?id=${params.id}&phone=${params.phone}&name=${params.name}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 获取电子名片详情
 * 
 */
export function vcardDetail(params) {
    return http({
        url: `/platform/vcard/${params.id}`,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 电子名片-分页查询访客数据
 * 
 */
export function VcardPageVisitor(params) {
    return http({
        url:`/platform/vcard/pageVisitor?userId=${params.id}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 应用管理-分页查询问题反馈
 * 
 */

export function getAppFeedback(params) {
    return http({
        url:`/platform/feedback/page?id=${params.id}&businessName=${params.businessName}&loginName=${params.loginName}&type=${params.type}&createTimeStart=${params.startTime}&createTimeEnd=${params.endTime}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 应用管理-查询问题详情
 * 
 */
export function feedbackDetail(params) {
    return http({
        url:`/platform/feedback/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 仿真工况-分页查询工况列表数据
 * 
 */

export function getAppConditions(params) {
    return http({
        url:`/platform/om/page?appId=${params.appId}&id=${params.id}&name=${params.name}&states=${params.states}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 仿真工况-新增修改工况
 * 
 */
export function editOm(params,method) {
    return http({
        url: "/platform/om",
        method:method,
        data: params,
    })
}
/**
 *  
 * 仿真工况-工况详情
 * 
 */
export function omDetail(params) {
    return http({
        url: `/platform/om/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 仿真工况-分页查询工况日志
 * 
 */

export function getAppConditionsLog(params) {
    return http({
        url:`/platform/om/log/page?modeId=${params.id}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 考试监控-查询批卷基本信息
 * 
 */
export function getGrade(params) {
    return http({
        url:`/platform/result/grade/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 考试监控-查询批卷题目分页
 * 
 */
export function getGradePage(params) {
    return http({
        url:`/platform/result/gradeList?resultId=${params.resultId}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 考试监控-批卷
 * 
 */

export function grade(params) {
    return http({
        url: "/platform/result/grade",
        method:"post",
        data: params,
    })
}
/**
 *  
 * 仿真考试-分页查询试卷列表
 * 
 */
export function getEmuPaper(params) {
    return http({
        url:`/platform/emuPaper/page?paperName=${params.paperName}&validPeriod=${params.validPeriod}&appId=${params.appId}&state=${params.state}&omId=${params.omId}&id=${params.id}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增仿真试卷
 * 
 */

export function editEmuPaper(params,method) {
    return http({
        url: "/platform/emuPaper",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询仿真试卷详情
 * 
 */

export function EmuPaperDetail(params) {
    return http({
        url:`/platform/emuPaper/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 删除仿真试卷详情
 * 
 */

export function deleteEmuPaperl(params) {
    return http({
        url:`/platform/emuPaper/${params.id}`,
        method:'DELETE',
        data: params,
    })
}
/**
 *  
 * 启用工况检测
 * 
 */

export function getCheckReopen(params) {
    return http({
        url:`/platform/emuPaper/checkReopen/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 工况列表
 * 
 */
export function omList(params) {
    return http({
        url:`/platform/om/list?appId=${params.appId}&id=${params.id}&name=${params.name}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 仪表阀门列表
 * 
 */
export function instrumentList(params) {
    return http({
        url:`/assess/emuPaper/instrumentList?appId=${params.appId}&search=${params.search}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 导入保存
 * 
 */
export function stepImportSave(params) {
    return http({
        url: "/platform/emuPaper/step/importSave",
        method:"post",
        data: params,
    })
}
/**
 *  
 * 过程列表
 * 
 */
export function processList(params) {
    return http({
        url:`/platform/emuPaper/process/list?paperId=${params.paperId}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 获取过程详情、删除过程
 * 
 */

export function getProcess(params,method) {
    return http({
        url: `/platform/emuPaper/process/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 新增编辑过程
 * 
 */
export function editProcess(params,method) {
    return http({
        url: `/platform/emuPaper/process`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 获取步骤列表
 * 
 */
export function stepList(params) {
    return http({
        url:`/platform/emuPaper/step/list?paperId=${params.paperId}&processId=${params.processId}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增编辑步骤
 * 
 */
export function editStep(params,method) {
    return http({
        url: `/platform/emuPaper/step`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 获取步骤详情
 * 
 */
export function getStep(params,method) {
    return http({
        url: `/platform/emuPaper/step/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 仿真试卷ID评分列表
 * 
 */
export function getemuComments(params) {
    return http({
        url: `/platform/emuPaper/commentList/${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 仿真考试成绩分析
 * 
 */
export function rasoScoreAnalysis(params) {
    return http({
        url: `/platform/assessResult/scoreAnalysis?paperId=${params.id}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 仿真分数段统计
 * 
 */
export function rasoSegmentList(params) {
    return http({
        url: "/platform/assessResult/segmentList",
        method:"post",
        data: params,
    })
}
/**
 *  
 * 考核步骤分析
 * 
 */
export function stepRankList(params) {
    return http({
        url: `/platform/assessResult/stepRankList?paperId=${params.id}&practiceMode=${params.practiceMode}&startTime=${params.startTime}&endTime=${params.endTime}&state=${params.state}`,
        method:'get',
        data: params,
    })
}
/**
 * 仿真考试记录分页
 * 
 */

export function rasoResultList(params) {
    return http({
        url:`/platform/assessResult/page?paperId=${params.id}&practiceMode=${params.practiceMode}&result=${params.result}&examiner=${params.examiner}&examinerPhone=${params.examinerPhone}&startTimeStart=${params.startTimeStart}&startTimeEnd=${params.startTimeEnd}&state=${params.state}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 * 仿真考试监控基本信息
 * 
 */
export function rasMonitor(params) {
    let ptype = (params.practiceMode == 1 || params.practiceMode == 0)  ? params.practiceMode : ''
    return http({
        url: `/platform/assessResult/monitor/?paperId=${params.id}&practiceMode=${ptype}`,
        method:"get",
        data: params,
    })
}
/**
 *  
 *仿真考核排行榜列表
 * 
 */
 export function rasoRankList(params) {
    return http({
        url: `/platform/assessResult/rankPage?paperId=${params.paperId}&practiceMode=${params.practiceMode}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
    })
}
/**
 * 仿真考试查看成绩单
 * 
 */
export function rasoResulttRanscript(params) {
    return http({
        url: `/assess/result/${params.id}`,
        method:"get",
        data: params,
    })
}
/**
 * 仿真考试监控日志
 * 
 */
export function rasoResultMonitorLog(params) {
    return http({
        url: `/platform/assessResult/log/list?resultId=${params.id}`,
        method:"get",
        data: params,
    })
}
/**
 *  
 * 删除记录
 * 
 */
export function rasoDeletResult(params) {
    return http({
        url: `/platform/assessResult/${params.id}`,
        method:'DELETE',
        data: params,
    })
}
/**
 * 仿真强制交卷
 * 
 */
export function rasoForceSubmit(params) {
    return http({
        url: `/platform/assessResult/forceSubmit/${params.id}`,
        method:"put",
        data: params,
    })
}
/**
 * 下载仪门阀表
 * 
 */
export function getInstrumentExport(params) {
    return http({
        url: `/assess/emuPaper/instrumentExport?appId=${params.appId}&search=${params.search}`,
        method:"get",
        data: params,
        responseType: "blob",
    })
}
/**
 * 触控屏分页查询
 * 
 */
export function touchList(params) {
    return http({
        url: `/platform/touch/page?name=${params.name}&id=${params.id}&state=${params.state}&template=${params.template}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
    })
}
/**
 * 新增编辑触摸内容
 * 
 */
export function editTouch(params,method) {
    return http({
        url: `/platform/touch`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 获取触摸内容详情、删除触摸
 * 
 */

export function getTouch(params,method) {
    return http({
        url: `/platform/touch/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 分页查询课程分类
 * 
 */

export function getcourseClassify(params) {
    return http({
        url:`/platform/courseClassify/page?name=${params.name}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增课程分类
 * 
 */
export function editCourse(params,method) {
    return http({
        url: "/platform/courseClassify",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询、删除课程
 * 
 */

export function getCourse(params,method) {
    return http({
        url: `/platform/courseClassify/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询课程分类
 * 
 */
export function getAllCourseClassify(params) {
    return http({
        url:`/platform/courseClassify/list?name=${params.name}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 分页查询证书分类
 * 
 */

export function getcertClassify(params) {
    return http({
        url:`/platform/certClassify/page?name=${params.name}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增证书分类
 * 
 */
export function editCert(params,method) {
    return http({
        url: "/platform/certClassify",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询、删除证书分类
 * 
 */

export function getCert(params,method) {
    return http({
        url: `/platform/certClassify/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询证书分类
 * 
 */
export function getAllCertClassify(params) {
    return http({
        url:`/platform/certClassify/list?name=${params.name}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 分页查询学员信息
 * 
 */

export function getcertRecipient(params) {
    return http({
        url:`/platform/certRecipient/page?name=${params.name}&idNo=${params.id}&phone=${params.phone}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增学员信息
 * 
 */
export function editCertInfo(params,method) {
    return http({
        url: "/platform/certRecipient",
        method:method,
        data: params,
    })
}
/**
 *  
 * 学员领取证书分页
 * 
 */
export function getcertReceive(params) {
    return http({
        url:`/platform/certificate/receive/page?recipientId=${params.recipientId}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 查询、删除证书学员信息
 * 
 */

export function deletCert(params,method) {
    return http({
        url: `/platform/certRecipient/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 证书列表分页
 * 
 */
export function getcertList(params) {
    return http({
        url:`/platform/certificate/page?name=${params.name}&id=${params.id}&classifyId=${params.classifyId}&state=${params.state}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增修改证书
 * 
 */
export function editCertificate(params,method) {
    return http({
        url: "/platform/certificate",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询、删除证书学员信息
 * 
 */

export function deletCertificate(params,method) {
    return http({
        url: `/platform/certificate/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 学员领取证书分页
 * 
 */
export function getcertReceive1(params) {
    return http({
        url:`/platform/certificate/receive/page?certificateId=${params.certificateId}&name=${params.name}&phone=${params.phone}&idNo=${params.idNo}&issueTimeStart=${params.issueTimeStart}&issueTimeEnd=${params.issueTimeEnd}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增证书领取人
 * 
 */
export function addcertReip(params) {
    return http({
        url: "/platform/certificate/receive",
        method:'post',
        data: params,
    })
}
/**
 *  
 * 证书领取人详情
 * 
 */

export function getReceive(params,method) {
    return http({
        url: `/platform/certificate/receive/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 课程列表分页
 * 
 */
export function getcourseList(params) {
    return http({
        url:`/platform/course/page?title=${params.title}&id=${params.id}&classifyId=${params.classifyId}&state=${params.state}&payType=${params.payType}&recommend=${params.recommend}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增修改课程
 * 
 */
export function addCourse(params,method) {
    return http({
        url: "/platform/course",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询、删除课程
 * 
 */

export function deletCourse(params,method) {
    return http({
        url: `/platform/course/${params.id}`,
        method:method,
        data: params,
    })
}

/**
 * 课程规格列表
 * 
 */

export function courseSkuList(params) {
    return http({
        url: `/platform/course/sku/list?courseId=${params.id}`,
        method:'get',
        data: params,
    })
}
/**
 * 课程章节列表
 * 
 */
export function courseChapterList(params) {
    return http({
        url: `/platform/courseChapter/list?courseId=${params.id}`,
        method:"get",
        data: params,
    })
}
/**
 * 新增章节
 * 
 */


export function editcourseHelpChapter(params,method) {
    return http({
        url: "/platform/courseChapter",
        method:method,
        data: params,
    })
}
/**
 * 章节详情
 * 
 */

export function courseChapterDetail(params,method) {
    return http({
        url: "/platform/courseChapter/" + params.id,
        method:method,
        data: params,
    })
}

/**
 * 预览课程列表
 * 
 */
export function prevoewCpurseList(params) {
    return http({
        url: `/platform/course/preview/${params.id}`,
        method:"get",
        data: params,
    })
}

/**
 * 预览课程关联试卷列表
 * 
 */
export function prevoewPaperList(params) {
    return http({
        url: `/platform/result/centList?courseId=${params.id}&state=${params.state}&practiceMode=${params.practiceMode}`,
        method:"get",
        data: params,
    })
}
/**
 * 数据分析-学习数据概况
 * 
 */
export function overviewCou(params) {
    return http({
        url: `/platform/course/overview?courseId=${params.id}`,
        method:"get",
        data: params,
    })
}
/**
 * 数据分析-学习数据概况
 * 
 */
export function lineData(params) {
    return http({
        url: `/platform/course/countRecordByDay?courseId=${params.id}&startTime=${params.starTime}&endTime=${params.endTime}`,
        method:"get",
        data: params,
    })
}
/**
 * 数据分析-完课数据概况
 * 
 */
export function lineData1(params) {
    return http({
        url: `/platform/course/countCompleteByDay?courseId=${params.id}&startTime=${params.starTime}&endTime=${params.endTime}`,
        method:"get",
        data: params,
    })
}
/**
 * 数据分析-学习详情分页
 * 
 */
export function tabData(params) {
    return http({
        url: `/platform/course/record/page?courseId=${params.id}&current=${params.current}&size=${params.size}`,
        method:"get",
        data: params,
    })
}
/**
 * 数据分析-销售情况
 * 
 */
export function saleData(params) {
    return http({
        url: `/platform/course/sale?courseId=${params.id}&startTime=${params.starTime}&endTime=${params.endTime}`,
        method:"get",
        data: params,
    })
}
/**
 * 数据分析-销售列表
 * 
 */
export function lineData2(params) {
    return http({
        url: `/platform/course/saleList?courseId=${params.id}&startTime=${params.starTime}&endTime=${params.endTime}`,
        method:"get",
        data: params,
    })
}
/**
 *  
 * 报警分类列表分页
 * 
 */
export function getAlarmClassify(params) {
    return http({
        url:`/platform/alarmClassify/page?appId=${params.appId}&name=${params.name}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 报警分类仿真系统列表
 * 
 */
export function alarmApplist(params) {
    return http({
        url:`/platform/app/list?parentClassifyId=2&type=1&state=1`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增报警分类
 * 
 */
export function editAlarm(params,method) {
    return http({
        url: "/platform/alarmClassify",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询、删除报警
 * 
 */

export function getAlarm(params,method) {
    return http({
        url: `/platform/alarmClassify/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 报警分类列表
 * 
 */
export function getAlarmClassify1(params) {
    return http({
        url:`/platform/alarmClassify/list?appId=${params.appId}&name=${params.name}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 报警列表分页
 * 
 */
export function alarmRuleList(params) {
    return http({
        url:`/platform/alarmRule/page?name=${params.name}&id=${params.id}&classifyId=${params.classifyId}&state=${params.state}&alarmLevel=${params.alarmLevel}&autoLock=${params.autoLock}&interlock=${params.interlock}&resetMode=${params.resetMode}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}&current=${params.current}&size=${params.size}&appId=${params.appId}`,
        method:'get',
        data: params,
    })
}

/**
 *  
 * 新增编辑报警
 * 
 */
export function editAlarmRule(params,method) {
    return http({
        url: "/platform/alarmRule",
        method:method,
        data: params,
    })
}
/**
 *  
 * 报警触发条件列表
 * 
 */
export function triggerAlarmRule(params) {
    return http({
        url:`/platform/alarmRule/listTrigger?ruleId=${params.ruleId}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 复位条件条件列表
 * 
 */
export function triggerAlarmRule1(params) {
    return http({
        url:`/platform/alarmRule/listReset?ruleId=${params.ruleId}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 查看删除报警规则
 * 
 */
export function getAlarmRule(params,method) {
    return http({
        url:`/platform/alarmRule/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 素材库分类分也
 * 
 */
export function materialClassify(params) {
    return http({
        url:`/platform/materialClassify/page?name=${params.name}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 素材库分类列表
 * 
 */
export function materialAllClassify(params) {
    return http({
        url:`/platform/materialClassify/list?name=${params.name}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增素材库分类
 * 
 */
export function editMaterialClassify(params,method) {
    return http({
        url: "/platform/materialClassify",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询、删除素材库分类
 * 
 */

export function getMaterialClassify(params,method) {
    return http({
        url: `/platform/materialClassify/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 素材库分页
 * 
 */
export function materialPage(params) {
    return http({
        url:`/platform/material/page?name=${params.name}&classifyId=${params.classifyId}&id=${params.id}&createTimeStart=${params.createTimeStart}&createTimeEnd=${params.createTimeEnd}&current=${params.current}&size=${params.size}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 新增修改素材库
 * 
 */
export function editMaterial(params,method) {
    return http({
        url: "/platform/material",
        method:method,
        data: params,
    })
}
/**
 *  
 * 查询、删除素材
 * 
 */

export function deletMaterial(params,method) {
    return http({
        url: `/platform/material/${params.id}`,
        method:method,
        data: params,
    })
}
/**
 *  
 * 批量修改素材分类
 * 
 */

export function batchUpdateClassify(params) {
    return http({
        url: `/platform/material/batchUpdateClassify`,
        method:'put',
        data: params,
    })
}
/**
 *  
 * 批量新增章节
 * 
 */

export function courseChapter(params) {
    return http({
        url: `/platform/courseChapter/batch/save`,
        method:'post',
        data: params,
    })
}
/**
 *  
 * 随机组卷题型数
 * 
 */
export function countOfQuestionType(params) {
    return http({
        url:`/platform/question/countOfQuestionType?questionClassifyId=${params.questionClassifyId}&paperId=${params.paperId}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 题型分析图表
 * 
 */
export function analysisType(params) {
    return http({
        url:`/platform/paper/paperQuestions/analysisType?paperId=${params.paperId}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 难度分析图表
 * 
 */
export function analysisTag(params) {
    return http({
        url:`/platform/paper/paperQuestions/analysisTag?paperId=${params.paperId}`,
        method:'get',
        data: params,
    })
}
/**
 *  
 * 试题排序
 * 
 */
export function paperQuestionsSort(params) {
    return http({
        url: `/platform/paper/paperQuestions/sort`,
        method:'put',
        data: params,
    })
}
/**
 * 导出word
 * 
 */
export function exportWord(params) {
    return http({
        url: `/exam/paper/exportWord?paperId=${params.paperId}&attention=${params.attention}&timeScore=${params.timeScore}&examinee=${params.examinee}`,
        method:"get",
        data: params,
        responseType: "blob",
    })
}